import { useFetch } from '../utils/fetch.util.js';

export const initializeUserinfo = async () => useFetch('/userinfo', { method: 'GET' });
